import Log from '../../../common/logging';
import { CancellableResult } from '../../../common/result';
import documentCapture from '../../../services/documentCapture';
import { DEFAULT_SUPPORTED_DOCUMENT_TYPES, DocumentType } from '../../../services/documentCapture/documentCapture';
import CompleteDocumentTask from '../background/CompleteDocumentTask';
import validationSteps from '../validationSteps';
import StepWorker, { StepWorkerResult } from './StepWorker';

export default class DocumentCaptureStep implements StepWorker {
  public requiresInit = false;

  private supportedDocumentTypes: DocumentType[];

  constructor(supportedDocumentTypes: DocumentType[] = DEFAULT_SUPPORTED_DOCUMENT_TYPES) {
    this.supportedDocumentTypes = supportedDocumentTypes;
  }

  public async processStep(validationId: string): Promise<StepWorkerResult> {
    const captureTokenResult = await validationSteps.getDocumentCaptureTokenStep(validationId);
    if (captureTokenResult.isFailed()) {
      return { result: CancellableResult.failed(captureTokenResult.failure()) };
    }

    const documentCaptureResult = await documentCapture.capture(
      captureTokenResult.success(),
      this.supportedDocumentTypes,
    );
    if (documentCaptureResult.isCancelled()) {
      return { result: CancellableResult.cancelled() };
    }

    if (documentCaptureResult.isFailed()) {
      return { result: CancellableResult.failed(documentCaptureResult.failure()) };
    }

    Log.debug('Document Id: ', documentCaptureResult.success());
    return {
      result: CancellableResult.noValueSuccess(),
      backgroundTask: new CompleteDocumentTask(validationId),
    };
  }
}
